
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/vara-skribenter",
      function () {
        return require("private-next-pages/(ocelot)/vara-skribenter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/vara-skribenter"])
      });
    }
  